import { colors } from '@ardoq/design-tokens';
import type { MultiLabelStyle } from '../types';

// Legacy blue multi-label styles
export const MULTILABEL_BORDERCOLOR = colors.blue200;
export const MULTILABEL_COLOR = colors.blue950;
export const GROUP_MULTILABEL_BACKGROUNDCOLOR = colors.blue50;
export const LEAF_MULTILABEL_BACKGROUNDCOLOR = colors.blue50;

// New grey multi-label styles for conditional formatting clarity
export const NEW_CONDITIONAL_FORMATTING_MULTILABEL_BORDERCOLOR = colors.grey300;
export const NEW_CONDITIONAL_FORMATTING_MULTILABEL_COLOR = colors.grey800;
export const NEW_CONDITIONAL_FORMATTING_GROUP_MULTILABEL_BACKGROUNDCOLOR =
  colors.grey200;
export const NEW_CONDITIONAL_FORMATTING_LEAF_MULTILABEL_BACKGROUNDCOLOR =
  colors.grey200;

export const legacyMultiLabelStyle: MultiLabelStyle = {
  strokeStyle: MULTILABEL_BORDERCOLOR,
  fillStyle: LEAF_MULTILABEL_BACKGROUNDCOLOR,
  groupFillStyle: GROUP_MULTILABEL_BACKGROUNDCOLOR,
  textColor: MULTILABEL_COLOR,
};

export const newConditionalFormattingMultiLabelStyle: MultiLabelStyle = {
  strokeStyle: NEW_CONDITIONAL_FORMATTING_MULTILABEL_BORDERCOLOR,
  fillStyle: NEW_CONDITIONAL_FORMATTING_LEAF_MULTILABEL_BACKGROUNDCOLOR,
  groupFillStyle: NEW_CONDITIONAL_FORMATTING_GROUP_MULTILABEL_BACKGROUNDCOLOR,
  textColor: NEW_CONDITIONAL_FORMATTING_MULTILABEL_COLOR,
};

export const DEFAULT_MULTI_LABEL_STYLE =
  newConditionalFormattingMultiLabelStyle;
